module.exports = __webpack_public_path__ + "img/chest-endomorph-female.d2bfa828.svg";